import get from 'lodash/get';
import moment from 'moment';
import {useMemo} from 'react';
import {useSelector} from 'react-redux';

import config from '../config/config';

const useMFANeeded = () => {
  const {
    deviceToken,
    deviceExp,
    email,
    deviceEmail
  } = useSelector(state => get(state, 'auth'));
  const mfaNeeded = (
    // !config().isStaging &&
    !!email &&
    (
      !deviceToken
      || (new Date(deviceExp)).valueOf() < (new Date()).valueOf()
      || email !== deviceEmail
    )
  );
  return useMemo(() => mfaNeeded, [mfaNeeded]);
};

export default useMFANeeded;
